export default abstract class QueryParamsUtils {
  public static getQueryParamsFromHash<T>(hashedParams: string): T {
    const params = {} as T;
    atob(hashedParams)
      .split('&')
      .forEach((param) => {
        const [key, value] = param.split('=');
        params[key] = value;
      });

    return params;
  }

  public static hashQueryParams(queryParams: string) {
    return btoa(queryParams);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/helpers/query-params-utils.ts